import React from 'react';
import { NavLink, useParams, useLocation } from 'react-router-dom';
import { Stack, Button } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const LINKS = [
  { path: 'home', label: 'Home' },
  { path: 'profile', label: 'My Profile' },
  { path: 'pledges', label: 'Pledges' },
  { path: 'donations', label: 'Donations' },
  { path: 'statements', label: 'Statements' },
  { path: 'donate', label: 'Donate', href: '/donate' },
];

export default function PortalTopNav({ disabled = false }) {
  const { id: routeDevoteeId } = useParams();
  const location = useLocation();
  const { staff } = useAuth();
  const subject =
    routeDevoteeId != null && String(routeDevoteeId).trim() !== ''
      ? String(routeDevoteeId)
      : staff?.portal && staff?.subject != null
        ? String(staff.subject)
        : null;
  const base = subject != null ? `/devotees/${subject}` : null;

  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      useFlexGap
      sx={{ mb: 0, columnGap: 1, rowGap: 1 }}
    >
      {LINKS.map(({ path, label, href }) => {
        if (path === 'donate' && location.pathname.startsWith('/donate')) return null;
        if (path !== 'donate' && !base) return null;
        const to = href || `${base}/${path}`;
        const isDonate = path === 'donate';
        if (isDonate) {
          return (
            <Button
              key={path}
              component={disabled ? 'button' : NavLink}
              to={disabled ? undefined : '/donate'}
              variant="outlined"
              color="secondary"
              size="small"
              disabled={disabled}
              sx={{
                fontWeight: 700,
                textDecoration: 'none',
                borderWidth: 2,
              }}
            >
              {label}
            </Button>
          );
        }
        return (
          <NavLink
            key={path}
            to={disabled ? location.pathname : to}
            style={{ textDecoration: 'none' }}
            onClick={disabled ? (e) => e.preventDefault() : undefined}
          >
            {({ isActive }) => (
              <Button
                variant={isActive && !disabled ? 'contained' : 'outlined'}
                color="primary"
                size="small"
                disabled={disabled}
              >
                {label}
              </Button>
            )}
          </NavLink>
        );
      })}
    </Stack>
  );
}
